import { APP } from '../config'
import PixiFps from "pixi-fps";

class SceneManager {
    init() {
        this.stage = APP.stage;
        this.list = {};
    }

    showFPS() {
        this.stage.addChild(new PixiFps());
    }

    load(sceneName, scene) {
        this.stage.addChild(scene.getScene());
        this.list[sceneName] = scene;
    }

    get(sceneName) {
        return this.list[sceneName];
    }

    push(sceneName) {
        this.get(sceneName).show();
        //TODO
    }

    pop() {
        if (this.stage.children.length === 0) { return; }
        //TODO
    }

    destroy() {
        for(const sceneName in this.list) {
            this.list[sceneName].destroy ? this.list[sceneName].destroy() : null
        }
    }
}

export default new SceneManager();